import React from "react"

export const HrSpacer = () => {
    return <hr />
}